import popupHandler from '../../../js/src/__page/popup';
import nextPrevNames from '../../../js/src/__page/archiveTeam';

function closerToggler() {
	jQuery(document).ready(function () {
		jQuery(document).click(function (event) {
			if (
				!jQuery(event.target).closest(
					'.trex-filters-nav-title.open, .trex-filters-types-title.open, .trex-filters-sort-title.open, .trex-filters-nav-filter'
				).length
			) {
				jQuery(
					'.trex-filters-nav-title.open, .trex-filters-types-title.open, .trex-filters-sort-title.open'
				).removeClass('open');
			}
		});
	});
}

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		popupHandler.init();
		nextPrevNames.init();
		closerToggler();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
